import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = { class: "titlebar-text" }
const _hoisted_6 = { class: "titlebar-actions" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1)
const _hoisted_8 = { class: "titlebar-actions-primary" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ui-card" }
const _hoisted_12 = { class: "ui-card-body" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_21 = {
  key: 0,
  class: "ui-card ui-mt-30"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
      /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Clientes")
      ])
    ])
  ])
], -1)
const _hoisted_23 = { class: "ui-card-body" }
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_26 = {
  key: 1,
  class: "ui-card ui-mt-30"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
      /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Regiões")
      ])
    ])
  ])
], -1)
const _hoisted_28 = { class: "ui-card-body" }
const _hoisted_29 = { class: "ant-row" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_31 = {
  key: 2,
  class: "ui-card ui-mt-30"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
      /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Estados")
      ])
    ])
  ])
], -1)
const _hoisted_33 = { class: "ui-card-body" }
const _hoisted_34 = { class: "ant-row" }
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_36 = {
  key: 3,
  class: "ui-card ui-mt-30"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
      /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Cidades")
      ])
    ])
  ])
], -1)
const _hoisted_38 = { class: "ui-card-body" }
const _hoisted_39 = { class: "ant-row" }
const _hoisted_40 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_41 = { class: "ui-card ui-mt-30" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
      /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Itens")
      ])
    ])
  ])
], -1)
const _hoisted_43 = { class: "ui-card-body" }
const _hoisted_44 = { class: "ant-row" }
const _hoisted_45 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_46 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_47 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Adicionar")
], -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { class: "ui-table" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ui-row header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-18 ui-cell ui-cell-editable" }, " Produto "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-5 ui-cell ui-cell-editable" }, " Preço R$ "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable ui-align-center" })
], -1)
const _hoisted_52 = { class: "ui-rows" }
const _hoisted_53 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-18 ui-cell ui-cell-editable",
  "data-title": "Produto"
}
const _hoisted_54 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-5 ui-cell ui-cell-editable",
  "data-title": "Preço R$"
}
const _hoisted_55 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable",
  "data-title": "Ações"
}
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "ui-button-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_caixa_selecao = _resolveComponent("caixa-selecao")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_combo_cliente = _resolveComponent("combo-cliente")!
  const _component_combo_regiao = _resolveComponent("combo-regiao")!
  const _component_combo_estado = _resolveComponent("combo-estado")!
  const _component_combo_cidade = _resolveComponent("combo-cidade")!
  const _component_combo_produto_definicao = _resolveComponent("combo-produto-definicao")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.appBase.titulo), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar()))
          }, _hoisted_10)
        ])
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_divider, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Tipo da Tabela")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_caixa_selecao, {
                      opcoes: _ctx.state.opcoesCaixaSelacao,
                      valor: _ctx.state.tabelaPreco.tipo,
                      "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.tabelaPreco.tipo) = $event))
                    }, null, 8, ["opcoes", "valor"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_form_item, { label: "Nome" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "255",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.tabelaPreco.nome) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.tabelaPreco.nome]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_a_form_item, { label: "Padrão" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _ctx.state.tabelaPreco.padrao,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.tabelaPreco.padrao) = $event)),
                          "button-style": "solid"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode("Não")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode("Sim")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_a_form_item, { label: "Status" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _ctx.state.tabelaPreco.status,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.tabelaPreco.status) = $event)),
                          "button-style": "solid"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode("Inativa")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode("Ativa")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_a_divider, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Descrição")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_editor_html, {
                      value: _ctx.state.tabelaPreco.descricao,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.tabelaPreco.descricao) = $event))
                    }, null, 8, ["value"])
                  ])
                ])
              ])
            ]),
            (_ctx.state.tabelaPreco.tipo === _ctx.ETipoTabelaPreco.Cliente)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_combo_cliente, {
                          multiplaSelecao: true,
                          codigos: _ctx.state.clientesSelecionados,
                          "onUpdate:codigos": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.clientesSelecionados) = $event))
                        }, null, 8, ["codigos"])
                      ])
                    ])
                  ])
                ]))
              : (_ctx.state.tabelaPreco.tipo === _ctx.ETipoTabelaPreco.Regiao)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_combo_regiao, {
                            multiplaSelecao: true,
                            codigos: _ctx.state.regioesSelecionadas,
                            "onUpdate:codigos": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.regioesSelecionadas) = $event))
                          }, null, 8, ["codigos"])
                        ])
                      ])
                    ])
                  ]))
                : (_ctx.state.tabelaPreco.tipo === _ctx.ETipoTabelaPreco.Estado)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_combo_estado, {
                              multiplaSelecao: true,
                              codigos: _ctx.state.estadosSelecionados,
                              "onUpdate:codigos": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.estadosSelecionados) = $event))
                            }, null, 8, ["codigos"])
                          ])
                        ])
                      ])
                    ]))
                  : (_ctx.state.tabelaPreco.tipo === _ctx.ETipoTabelaPreco.Cidade)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _hoisted_37,
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createVNode(_component_combo_cidade, {
                                multiplaSelecao: true,
                                codigos: _ctx.state.cidadesSelecionadas,
                                "onUpdate:codigos": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.cidadesSelecionadas) = $event))
                              }, null, 8, ["codigos"])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", null, [
                  _createVNode(_component_a_form, { layout: "vertical" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _createVNode(_component_a_form_item, { label: "Produto" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_combo_produto_definicao, {
                                codigo: _ctx.state.novoItemPreco.codigoProdutoDefinicao,
                                "onUpdate:codigo": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.novoItemPreco.codigoProdutoDefinicao) = $event)),
                                codigoProduto: _ctx.state.novoItemPreco.codigoProduto,
                                "onUpdate:codigoProduto": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.novoItemPreco.codigoProduto) = $event))
                              }, null, 8, ["codigo", "codigoProduto"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_a_form_item, { label: "Preço" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                class: "ui-full",
                                valor: _ctx.state.novoItemPreco.preco,
                                "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.novoItemPreco.preco) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createVNode(_component_a_form_item, { label: " " }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "ui-button -primary ui-mh-32",
                                type: "button",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.adicionarItemTabelaPreco()))
                              }, _hoisted_49)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createElementVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _createElementVNode("div", _hoisted_52, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.tabelaPreco.itens, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: _normalizeClass(item.removido?'ui-d-none':'ant-row ui-row ui-row-editable')
                        }, [
                          _createElementVNode("div", _hoisted_53, [
                            _createVNode(_component_combo_produto_definicao, {
                              codigo: item.codigoProdutoDefinicao,
                              "onUpdate:codigo": ($event: any) => ((item.codigoProdutoDefinicao) = $event),
                              codigoProduto: item.codigoProduto,
                              "onUpdate:codigoProduto": ($event: any) => ((item.codigoProduto) = $event),
                              disabled: true
                            }, null, 8, ["codigo", "onUpdate:codigo", "codigoProduto", "onUpdate:codigoProduto"])
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _createVNode(_component_campo_numerico, {
                              class: "ui-full",
                              onValorDigitado: ($event: any) => (_ctx.itemAlterado(index)),
                              valor: item.preco,
                              "onUpdate:valor": ($event: any) => ((item.preco) = $event)
                            }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                          ]),
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("button", {
                              class: "ui-button ui-mh-32 ui-full",
                              type: "button",
                              onClick: ($event: any) => (_ctx.removerItemTabelaPreco(index))
                            }, [
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_icone, { nome: "excluir" })
                                ])
                              ])
                            ], 8, _hoisted_56)
                          ])
                        ], 2))
                      }), 128))
                    ])
                  ], 512), [
                    [_vShow, (_ctx.state.tabelaPreco.itens.length > 0)]
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}